import {
  Box,
  Chip,
  IconButton,
  Link,
  Typography,
  useTheme
} from "@mui/material";
import React, { useState } from "react";
import { BCPXmark } from "../icons/bcp/BCPIcons";
import { postData } from "./UtilityFunctions";
import { refreshTokens } from "../user/BCPAuth";
import { isAppMode } from "../../global/AppOverlay";
import ModalLoadingFull from "../modals/ModalLoadingFull";
import { purple } from "@mui/material/colors";

export function BetaPill(props) {
  const { sx, ...rest } = props;
  return (
    <Chip
      variant="solid"
      color="error"
      label="BETA"
      sx={{ backgroundColor: purple[500], ...sx }}
      {...rest}
    />
  );
}
export default function BetaFeaturePopup(props) {
  const { authContext, hideButton, show } = props;

  const [isVisible, setIsVisible] = useState(
    show || authContext?.authState?.identity?.betaUser === "true"
  );
  const [loading, setLoading] = useState(false);
  const theme = useTheme();
  const appMode = isAppMode();

  if (!isVisible || appMode) {
    return <></>;
  } else {
    return (
      <Box
        sx={{
          p: 1,
          border: `1px solid ${theme?.palette?.text?.disabled}`,
          borderRadius: "4px",

          display: "flex",
          justifyContent: "space-between",
          alignItems: "center"
        }}
      >
        <Typography variant="body1">
          {`You are currently using a beta version of this page with experimental features. As a result, you may encounter issues. To view the regular version of this page and disable beta features, `}
          {hideButton ? (
            `toggle "Beta Features" in Account Settings.`
          ) : (
            <Link
              onClick={async () => {
                try {
                  setLoading(true);
                  const apiBeta = await postData(
                    `/users/${authContext?.authState?.identity?.userId}/setBeta`,
                    {
                      beta: Boolean(
                        !(authContext?.authState?.identity?.betaUser === "true")
                      )
                    }
                  );

                  await refreshTokens();
                  if (apiBeta) window.location.reload();
                } catch (err) {
                  console.error(err);
                } finally {
                  setLoading(true);
                }
              }}
              sx={{ cursor: "pointer" }}
            >
              {`click here.`}
            </Link>
          )}
        </Typography>
        <IconButton
          aria-label="cancel"
          color="error"
          onClick={() => {
            setIsVisible(false);
          }}
        >
          <BCPXmark />
        </IconButton>
        {loading && <ModalLoadingFull />}
      </Box>
    );
  }
}
